import React, { FC } from 'react';

import { Button, FlexRow, SvgIcon, Text } from '@portal/common/components';
import _ from '@portal/common/locale';
import { Theme, styled } from '@portal/common/theme';

const Wrapper = styled(FlexRow)<{ theme: Theme }>(({ theme }) => ({
    padding: '8px 0',
    backgroundColor: theme?.color?.gray90,
    fontSize: 16,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme?.zIndex?.popups,
}));

const StyledText = styled(Text)<{ theme: Theme }>(({ theme }) => ({
    marginRight: 16,
    color: theme?.color?.white,
    fontWeight: theme?.typography?.fontWeight?.medium,
}));

const CloseIcon = styled(SvgIcon)({
    position: 'absolute',
    right: 20,
});

const StyledButton = styled(Button)({
    minHeight: 40,
    height: 40,
});

type Props = {
    onStart: () => void;
    onClose: () => void;
};

const SurveyBanner: FC<Props> = ({ onStart, onClose }) => (
    <Wrapper align="center" justify="center">
        <StyledText>{_('survey_banner_title')}</StyledText>
        <StyledButton color="primary" onClick={onStart}>
            {_('start_survey_button_label')}
        </StyledButton>
        <CloseIcon
            size="large"
            src="/icons/ic-cross.svg"
            color={(theme) => theme?.color?.gray40}
            onClick={onClose}
            aria-label="Close survey banner"
        />
    </Wrapper>
);

export default SurveyBanner;
